import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Dialog } from '@sas/nova-commons/components/Dialog';
import { DualSelector } from '@sas/nova-commons/components/DualSelector';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ReportContextMenuState } from '../../store/reportContextMenu/ReportContextMenuState';
import { ManageColumnsState, } from '../../store/manageColumns/manageColumnsState';
import { useI18n } from '../../locale/I18nContext';
const ManageColumnsDialogBase = (props) => {
    const localize = useI18n();
    const [displayedColumns, setDisplayedColumns] = useState(undefined);
    return (_jsx(Dialog, Object.assign({ hideAnimation: true, resizable: true, style: { width: '80%' }, onOpen: props.contextMenuActions.close, isOpen: props.columnsData.isOpen || false, title: localize({ key: 'ManageColumns.title.txt' }), firstAction: {
            text: localize({ key: 'ManageColumns.ok.txt' }),
            onPress: () => {
                props.actions.notifyUpdateDisplayedColumns(displayedColumns || []);
                props.actions.update({
                    isOpen: false,
                    displayedItems: undefined,
                    hiddenItems: undefined,
                });
                setDisplayedColumns(undefined);
            },
            isDefault: true,
            disabled: displayedColumns === undefined,
        }, dismissAction: {
            text: localize({ key: 'ManageColumns.cancel.txt' }),
            onPress: () => {
                props.actions.update({
                    isOpen: false,
                    displayedItems: undefined,
                    hiddenItems: undefined,
                });
                setDisplayedColumns(undefined);
            },
        } }, { children: _jsx(DualSelector, { type: "list", mode: "move", dataFieldKeys: ['label', 'column'], sourceAttribute: [
                {
                    label: localize({ key: 'ManageColumns.hiddenColumns.txt' }),
                    data: props.columnsData.hiddenItems,
                    hideSearch: true,
                },
            ], targetAttribute: [
                {
                    label: localize({ key: 'ManageColumns.displayedColumns.txt' }),
                    data: props.columnsData.displayedItems,
                    hideSearch: true,
                },
            ], onTargetChange: (items) => {
                setDisplayedColumns(items);
            } }) })));
};
export const ManageColumnsDialog = connect((state) => ({ columnsData: state.ui.manageColumns }), (dispatch) => ({
    actions: bindActionCreators(ManageColumnsState.actions, dispatch),
    contextMenuActions: bindActionCreators(ReportContextMenuState.actions, dispatch),
}))(ManageColumnsDialogBase);
